import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Global styles
import './index.css';
import './styles/global.css';

// Create and render root
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
